export default "__VITE_ASSET__DdZjW_TZ__"